import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRest } from "@karpeleslab/react-klbfw-hooks";

// component
import DisplayArticle from "components/Cms/DisplayArticle";
import NotFound from "components/NotFound/NotFound";

const InformationDetail = () => {
  const { slug } = useParams();
  const [notFound, setNotFound] = useState(false);

  const [article] = useRest(
    `Content/Cms/@information:loadSlug`,
    { slug: decodeURIComponent(slug) },
    true
  );

  useEffect(() => {
    if (article === false) {
      setNotFound(true);
    } else if (article !== null) {
      setNotFound(false);
    }
  }, [article]);

  return (
    <>
      {!notFound && <DisplayArticle article={article} />}
      {notFound && <NotFound backType="back" />}
    </>
  );
};

export default InformationDetail;
